module.exports = __webpack_public_path__ + "images/404.1788921444950.png";